<template>
  <div class="medicaldata">
    <div class="menu_list">
      <el-menu class="menu" :default-active="activeIndex" mode="horizontal" @select="handleSelect">
        <el-menu-item index="drug">药品库存查询</el-menu-item>
        <el-menu-item index="mutexDrugs">相反相畏管理</el-menu-item>
        <el-menu-item index="drugExcess">药品超量管理</el-menu-item>
        <el-menu-item v-if="companyId == 10" index="acupoint">理疗穴位管理</el-menu-item>
        <el-menu-item v-if="companyId == 10" index="physio">理疗项目查询</el-menu-item>
        <el-menu-item v-if="companyId == 10" index="comboRecipe">隐秘处方管理</el-menu-item>
        <el-menu-item v-if="companyId == 10" index="physioCategoryManage">理疗分类管理</el-menu-item>
        <el-menu-item index="ingredient">辅料管理</el-menu-item>
        <el-menu-item index="SetsAndGroups">药品集合与分组</el-menu-item>
        
      </el-menu>
    </div>
    <div class="content">
      <components :is="componentMap[activeIndex]"></components>
    </div>
  </div>
</template>

<script lang="js">
import Drug from "./Drug.vue"
import MutexDrugs from "./MutexDrugs.vue"
import DrugExcess from "./DrugExcess.vue"
import Acupoint from "./Acupoint.vue"
import Physio from "./Physio.vue"
import ComboRecipe from "./ComboRecipe.vue"
import PhysioCategoryManage from "./PhysioCategoryManage.vue"
import ingredient from "./ingredient.vue"
import SetsAndGroups from './setsAndGroups.vue'

export default {
  name: "Scheduling",
  components: { Drug, MutexDrugs, DrugExcess, Acupoint, Physio, ComboRecipe, PhysioCategoryManage,ingredient, SetsAndGroups },
  data() {
    return {
      activeIndex: "drug",
      componentMap: {
        'drug': Drug,
        'mutexDrugs': MutexDrugs,
        'drugExcess': DrugExcess,
        'acupoint': Acupoint,
        'physio': Physio,
        'comboRecipe': ComboRecipe,
        'physioCategoryManage': PhysioCategoryManage,
        'ingredient': ingredient,
        'SetsAndGroups': SetsAndGroups,
      },
      companyId:this.$session.get('user').companyId 
    }
  },
  created() {
    let index = this.$session.get('medicalDataIndex')
    if (index) {
      this.activeIndex = index
    }
  },
  methods:{
    // 切换当前显示组件
    handleSelect(key) {
      this.activeIndex = key;
      this.$session.set('medicalDataIndex', key);
    }
  }
};
</script>

<style lang="less" scoped>
  .medicaldata {
    width: 100%;
    height: 100%;
    background-color: #FFFFFF;
  }

  .menu_list {
    width: 100%;
    height: 56px;
  }

  .menu {
    box-sizing: border-box;
    width: 100%;
    height: 100%;
  }

  .menu_list /deep/.el-menu--horizontal>.el-menu-item {
    box-sizing: border-box;
    height: 56px;
    line-height: 56px;
  }

  .content {
    width: 100%;
    height: calc(100% - 56px);
    overflow-x: hidden;
    overflow-y: auto;
  }
</style>
